import { render, staticRenderFns } from "./ConnectionInform.vue?vue&type=template&id=55521ea6&scoped=true"
import script from "./ConnectionInform.vue?vue&type=script&lang=js"
export * from "./ConnectionInform.vue?vue&type=script&lang=js"
import style0 from "./ConnectionInform.vue?vue&type=style&index=0&id=55521ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55521ea6",
  null
  
)

export default component.exports